(function(){
  /* Inside-the-app tour: auto switches every 6s, tap to jump */
  document.querySelectorAll('[data-tour]').forEach(function(tour){
    var items=[].slice.call(tour.querySelectorAll('.t-tour-item'));
    var layers=[].slice.call(tour.querySelectorAll('.t-tour-layer'));
    var STEP=6000, active=0, timer=null;
    function show(i){
      active=i;
      items.forEach(function(el,j){
        var on=j===i; el.classList.toggle('is-active',on);
        el.querySelector('button').setAttribute('aria-expanded',on?'true':'false');
        var bar=el.querySelector('.t-bar');
        if(bar){bar.style.transition='none';bar.style.width='0';if(on){void bar.offsetWidth;bar.style.transition='width '+STEP+'ms linear';bar.style.width='100%';}}
      });
      layers.forEach(function(el,j){el.style.opacity=j===i?'1':'0';el.setAttribute('aria-hidden',j===i?'false':'true');});
      clearTimeout(timer); timer=setTimeout(function(){show((active+1)%items.length);},STEP);
    }
    items.forEach(function(el,j){el.querySelector('button').addEventListener('click',function(){show(j);});});
    if(items.length) show(0);
  });

  /* Little interactive app cards: cheer, check in, RSVP */
  document.querySelectorAll('[data-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var on=btn.getAttribute('aria-pressed')!=='true';
      btn.setAttribute('aria-pressed',on?'true':'false');
      var lab=btn.querySelector('[data-label]'); if(lab) lab.textContent=on?btn.dataset.on:btn.dataset.off;
      var card=btn.closest('article')||btn.parentElement;
      if(card){
        if(on) card.setAttribute('data-checked',''); else card.removeAttribute('data-checked');
        card.querySelectorAll('[data-count]').forEach(function(c){c.textContent=on?c.dataset.countOn:c.dataset.count;});
      }
    });
  });

  /* Partner applications go straight to the TGHQ admin portal */
  var SB_URL='https://mxskrpqjoyfhpucpyril.supabase.co';
  var SB_KEY='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14c2tycHFqb3lmaHB1Y3B5cmlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2NTgyMjIsImV4cCI6MjA5NjIzNDIyMn0.HHJuLTuwMjS_JP90UbVJQZdJ3tIyop3QbH4blju6Zkw';
  document.querySelectorAll('[data-partner-form]').forEach(function(form){
    var err=form.querySelector('[data-form-error]');
    var done=form.parentElement.querySelector('[data-form-done]');
    var btn=form.querySelector('button[type=submit]'), label=btn.textContent;
    function val(n){var el=form.elements[n];return el?String(el.value||'').trim():'';}
    function fail(msg,field){err.textContent=msg;if(field&&form.elements[field])form.elements[field].focus();}
    form.addEventListener('submit',function(e){
      e.preventDefault(); err.textContent='';
      var role=val('role')||'founder';
      if(val('name').length<2) return fail('Add your name.','name');
      if(form.elements.business_name && !val('business_name')) return fail('Add your community or studio name.','business_name');
      if(role==='affiliate' && !val('instagram')) return fail('Add your handle.','instagram');
      if(form.elements.platform && !val('platform')) return fail('Choose where you post most.','platform');
      if(!val('audience')) return fail('Choose a size.','audience');
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('email'))) return fail('Add a valid email address.','email');
      if(!form.elements.consent.checked) return fail('Tick the box so we can contact you.','consent');
      btn.disabled=true; btn.textContent='Sending...';
      var about=form.elements.platform?('Posts mostly on '+val('platform')):null;
      fetch(SB_URL+'/rest/v1/rpc/submit_partner_application',{
        method:'POST',
        headers:{apikey:SB_KEY,Authorization:'Bearer '+SB_KEY,'Content-Type':'application/json'},
        body:JSON.stringify({p_role:role,p_name:val('name'),p_email:val('email'),p_instagram:val('instagram')||null,
          p_business_name:val('business_name')||null,p_city:val('city')||null,p_audience:val('audience')||null,p_about:about})
      }).then(function(r){return r.json().catch(function(){return {};}).then(function(b){if(!r.ok)throw new Error(b.message||'Something went wrong. Try again in a moment.');return b;});})
      .then(function(b){
        fetch(SB_URL+'/functions/v1/partner-email',{method:'POST',headers:{apikey:SB_KEY,Authorization:'Bearer '+SB_KEY,'Content-Type':'application/json'},body:JSON.stringify({id:b.id,kind:'submitted'})}).catch(function(){});
        form.hidden=true; if(done){done.hidden=false;done.style.display='flex';}
      })
      .catch(function(ex){fail(ex.message);})
      .finally(function(){btn.disabled=false;btn.textContent=label;});
    });
  });
})();
